// src/context/ChatProvider.tsx

import React from "react";
import { useChatStore } from "../store/chatStore";

export const ChatProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return <>{children}</>;
};

export const useChat = () => {
  const selectedConversation = useChatStore(
    (state) => state.selectedConversation,
  );
  const setSelectedConversation = useChatStore(
    (state) => state.setSelectedConversation,
  );
  const clearSelectedConversation = useChatStore(
    (state) => state.clearSelectedConversation,
  );

  return {
    selectedConversation,
    setSelectedConversation,
    clearSelectedConversation,
  };
};
